<template>
  <div class="order-div">
    <Card>
      <p slot="title">
        {{ $t("orderInfo") }}
      </p>
      <Row :gutter="10">
        <Col span="6">
          <FormItem :label="$t('clientName')" prop="client_id">
            <Select
              v-model="dataDetails.client_id"
              filterable
              clearable
              :placeholder="$t('select') + $t('clientName')"
              :filter-by-label="true"
            >
              <Option
                v-for="item in clientList"
                :value="item.id"
                :key="item.id"
                :label="item.account"
                >{{ item.account }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <!-- <Col span="8">
          <FormItem :label="$t('orderservice')" prop="cargoInfo.service">
            <RadioGroup
              v-model="dataDetails.cargoInfo.service"
              @on-change="changeRadio"
            >
              <Radio
                :label="item"
                border
                v-for="item in serviceList"
                :key="item"
              >
              </Radio>
            </RadioGroup>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem :label="$t('order_price')">
            <Input
              v-model="dataDetails.cargoInfo.ncndAmt"
              placeholder="Please Enter NcndAmt"
              :disabled="disabledPrice"
            ></Input>
          </FormItem>
        </Col> -->
        <Col span="6">
          <FormItem :label="$t('battery')" prop="cargoInfo.battery">
            <RadioGroup v-model="dataDetails.cargoInfo.battery">
              <Radio
                border
                :label="item.val"
                v-for="item in batteryList"
                :key="item.val"
              >
                {{ item[$i18n.locale] }}
              </Radio>
            </RadioGroup>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="$t('totalNoofpieces')" prop="cargoInfo.noofPieces">
            <Input
              v-model="dataDetails.cargoInfo.noofPieces"
              :placeholder="$t('enter') + $t('totalNoofpieces')"
            ></Input>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="$t('wight')" prop="cargoInfo.weight">
            <Input
              v-model="dataDetails.cargoInfo.weight"
              :placeholder="$t('enter') + $t('wight')"
            >
              <span slot="append">KG</span>
            </Input>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="$t('is_solely')" prop="cargoInfo.is_solely">
            <RadioGroup v-model="dataDetails.cargoInfo.is_solely">
              <Radio border label="YES">
                {{ $t("YES") }}
              </Radio>
              <Radio border label="NO">
                {{ $t("NO") }}
              </Radio>
            </RadioGroup>
          </FormItem>
        </Col>
        <Col span="6" v-if="dataDetails.cargoInfo.is_solely == 'YES'">
          <FormItem :label="$t('documents')">
            <Input
              v-model="dataDetails.cargoInfo.documents"
              :placeholder="$t('enter') + $t('documents')"
            ></Input>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="$t('CODCurrency')">
            <Select
              v-model="dataDetails.cargoInfo.cod_currency"
              :placeholder="$t('CODCurrency')"
            >
              <Option
                v-for="item in currencyList"
                :value="item.code"
                :key="item.code"
                :label="item.title + '(' + item.code + ')'"
              ></Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="$t('CODAmount')">
            <InputNumber
              v-model="dataDetails.cargoInfo.ncndAmt"
              :placeholder="$t('CODAmount')"
              style="width: 100%"
              :step="0.01"
              :min="0"
            ></InputNumber>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="$t('CODServiceCharge')">
            <InputNumber
              v-model="dataDetails.cargoInfo.cod_handlefee"
              :placeholder="$t('CODServiceCharge')"
              style="width: 100%"
              :step="0.01"
              :min="0"
            ></InputNumber>
          </FormItem>
        </Col>

        <Col span="6">
          <FormItem :label="$tz('体积,预报')">
            <InputNumber
              v-model="dataDetails.consigneeInfo.claim_volume"
              :placeholder="$tz('体积,预报')"
              style="width: 100%"
              :step="0.01"
              :min="0"
            ></InputNumber>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="$t('Remarks')" prop="remark">
            <Input
              type="textarea"
              v-model="dataDetails.remark"
              :placeholder="$t('enter') + $t('Remarks')"
              :rows="1"
            ></Input>
          </FormItem>
        </Col>
      </Row>
    </Card>
    <Card style="margin: 10px auto">
      <p slot="title">
        {{ $t("shippingInfo") }}
      </p>
      <Row :gutter="10">
        <Col span="8">
          <FormItem :label="$t('company')" prop="consigneeInfo.company">
            <Select
              v-model="dataDetails.consigneeInfo.company"
              filterable
              clearable
              :placeholder="$t('select') + $t('company')"
              @on-change="serviceChange"
            >
              <Option
                v-for="item in seiviceList"
                :value="item.service_code"
                :key="item.id"
                >{{
                  item[
                    $i18n.locale === "zh-CN"
                      ? "service_name"
                      : "service_name_en"
                  ]
                }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col span="8" v-if="dataDetails.consigneeInfo.company === 'shuangqing'">
          <FormItem :label="$tz('平台')" prop="consigneeInfo.platform">
            <Select
              v-model="dataDetails.consigneeInfo.platform"
              filterable
              clearable
              :placeholder="$tz('请选择,平台')"
            >
              <Option
                v-for="item in platform"
                :value="item.value"
                :key="item.value"
                >{{ item.label }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem :label="$t('from_country')" prop="consigneeInfo.origin">
            <Select
              v-model="dataDetails.consigneeInfo.origin"
              filterable
              :placeholder="$t('select') + $t('from_country')"
              @on-change="changeFrom"
            >
              <Option
                v-for="item in fromCountry"
                :value="item.code"
                :key="item.code"
                >{{ item.title }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem :label="$t('target_country')" prop="consigneeInfo.country">
            <Select
              v-model="dataDetails.consigneeInfo.country"
              filterable
              :placeholder="$t('select') + $t('target_country')"
              @on-change="changeTo"
            >
              <Option
                v-for="item in toCountry"
                :value="item.to_country.code"
                :key="item.to_country.code"
                :disabled="filterCountry(item)"
                >{{ item.to_country.title }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col
          v-if="
            ['men', 'AIR-Truck', 'SEA-Truck'].includes(
              dataDetails.consigneeInfo.company
            )
          "
          span="8"
        >
          <FormItem :label="$t('city_name')" prop="consigneeInfo.city_id">
            <Select
              v-model="dataDetails.consigneeInfo.city_id"
              filterable
              clearable
              :placeholder="$t('select') + $t('city_name')"
              :disabled="disabledCity"
            >
              <Option
                v-for="item in cityList"
                :value="item.id"
                :key="item.id"
                >{{ item.title }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <template
          v-if="
            !['men', 'AIR-Truck', 'SEA-Truck'].includes(
              dataDetails.consigneeInfo.company
            )
          "
        >
          <Col span="8">
            <FormItem
              :label="$t('warehouseAddress')"
              prop="consigneeInfo.storeLocation"
            >
              <Select
                v-model="dataDetails.consigneeInfo.storeLocation"
                filterable
                :placeholder="$t('select') + $t('warehouseAddress')"
                @on-change="changeWarehouse"
              >
                <Option
                  v-for="item in warehouseList"
                  :value="item.code"
                  :key="item.code"
                  :disabled="item.selected == 0"
                  >{{ item.code }}</Option
                >
              </Select>
            </FormItem>
          </Col>
        </template>
        <Col span="8">
          <FormItem :label="$t('method_name')" prop="consigneeInfo.transport">
            <Select
              v-model="dataDetails.consigneeInfo.transport"
              filterable
              :placeholder="$t('select') + $t('method_name')"
            >
              <Option
                v-for="item in transport"
                :value="item.method_code"
                :key="item.method_code"
                :disabled="item.selected == 0"
                >{{ item.method_name }}-{{ item.method_code }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem :label="$t('Area')" prop="consigneeInfo.area">
            <Input
              type="textarea"
              v-model="dataDetails.consigneeInfo.area"
              placeholder="please Enter area"
              :rows="1"
            ></Input>
          </FormItem>
        </Col>
        <template
          v-if="
            ['men', 'AIR-Truck', 'SEA-Truck'].includes(
              dataDetails.consigneeInfo.company
            )
          "
        >
          <Col span="8">
            <FormItem :label="$t('contact')" prop="consigneeInfo.contact">
              <Input
                v-model="dataDetails.consigneeInfo.contact"
                filterable
                :placeholder="$t('enter') + $t('contact')"
              >
              </Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label="$t('warehousePhone')" prop="consigneeInfo.mobile">
              <Input
                v-model="dataDetails.consigneeInfo.mobile"
                :placeholder="$t('enter') + $t('warehousePhone')"
              >
                <span slot="prepend">{{ countryCode }}</span>
              </Input>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem
              :label="$t('warehouseAddress1')"
              prop="consigneeInfo.address"
              style="width: 100%"
            >
              <Input
                type="textarea"
                v-model="dataDetails.consigneeInfo.address"
                :placeholder="$t('enter') + $t('warehouseAddress1')"
                :rows="2"
                style="width: 100%"
              ></Input>
            </FormItem>
          </Col>
        </template>
      </Row>
    </Card>
    <Card class="table-card">
      <p slot="title">
        {{ $t("doubleInfo") }}
      </p>
      <Table
        :columns="tableTitle"
        :data="dataDetails.invoiceInfo"
        border
        stripe
        :height="180"
      >
        <template
          v-for="(item, index1) in tableTitle"
          :slot="item.slot"
          slot-scope="{ index }"
        >
          <template v-if="item.button">
            <FormItem
              :label-width="0"
              :key="item.slot"
              style="margin-top: 10px"
            >
              <template v-if="index == 0">
                <Button
                  type="primary"
                  style="margin-right: 10px"
                  @click="addSubmit"
                  icon="md-add"
                  :key="index1"
                >
                  {{ $t("add") }}
                </Button>
              </template>
              <Button
                type="warning"
                @click="delSubmit(index)"
                icon="md-trash"
                :key="item.slot"
                :disabled="dataDetails.invoiceInfo.length == 1"
              >
                {{ $t("delete") }}
              </Button>
            </FormItem>
          </template>
          <FormItem
            :label-width="0"
            :key="item.slot"
            :prop="'invoiceInfo.' + index + '.' + item.slot"
            :rules="item.rules"
            v-else
            style="margin-top: 10px"
          >
            <Input
              v-model="dataDetails.invoiceInfo[index][item.slot]"
              :placeholder="$t('enter') + item.title"
              v-if="item.input"
            >
            </Input>
            <InputNumber
              v-model="dataDetails.invoiceInfo[index][item.slot]"
              :placeholder="$t('enter') + item.title"
              v-else
              :step="1"
              :min="0"
              style="width: 100%"
            >
            </InputNumber>
          </FormItem>
        </template>
      </Table>
    </Card>
    <Card
      class="table-card"
      v-if="dataDetails.consigneeInfo.platform === '速卖通'"
      style="margin-top: 10px"
    >
      <p slot="title">
        {{ $tz("平台货物详情") }}
      </p>
      <Table
        :columns="tableTitle1"
        :data="dataDetails.platformInfo"
        border
        stripe
        :height="180"
      >
        <template
          v-for="(item, index1) in tableTitle1"
          :slot="item.slot"
          slot-scope="{ index }"
        >
          <template v-if="item.button">
            <FormItem
              :label-width="0"
              :key="item.slot"
              style="margin-top: 10px"
            >
              <template v-if="index == 0">
                <Button
                  type="primary"
                  style="margin-right: 10px"
                  @click="addPlatform"
                  icon="md-add"
                  :key="index1"
                >
                  {{ $t("add") }}
                </Button>
              </template>
              <Button
                type="warning"
                @click="delPlatform(index)"
                icon="md-trash"
                :key="item.slot"
                :disabled="dataDetails.platformInfo.length == 1"
              >
                {{ $t("delete") }}
              </Button>
            </FormItem>
          </template>
          <FormItem
            :label-width="0"
            :key="item.slot"
            :prop="'platformInfo.' + index + '.' + item.slot"
            :rules="item.rules"
            v-else
            style="margin-top: 10px"
          >
            <Input
              v-model="dataDetails.platformInfo[index][item.slot]"
              :placeholder="item.placeholder"
              v-if="item.input"
            >
            </Input>
            <InputNumber
              v-model="dataDetails.platformInfo[index][item.slot]"
              :placeholder="$t('enter') + item.title"
              v-else
              :step="1"
              :min="0"
              style="width: 100%"
            >
            </InputNumber>
          </FormItem>
        </template>
      </Table>
    </Card>
  </div>
</template>

<script>
import { getAddress, getService, getServiceCountry } from "@/api/double/list";
import { getAllClient } from "@/api/user/client";
import {getCountry, getCountryCity} from "@/api/system/country";
import { getCurrency } from "@/api/finance/currency";
import { getCity } from "@/api/system/city";
import { platformType } from "@/api/public";
export default {
  props: {
    dataDetails: {
      type: Object,
    },
    disabledPrice: {
      type: Boolean,
    },
  },
  data() {
    return {
      platform: [],
      serviceList: ["NCND", "NOR"],
      batteryList: [
        { "zh-CN": "是", "en-US": "YES", val: 1 },
        { "zh-CN": "否", "en-US": "NO", val: 0 },
      ],
      tableTitle: [
        {
          title: this.$t("cargoNumber"),
          align: "center",
          slot: "cargoNumber",
          input: true,
        },
        {
          title: this.$t("shopName"),
          align: "center",
          slot: "shopName",

          input: true,
        },
        {
          title: this.$t("caseNumber"),
          align: "center",
          slot: "caseNumber",
          rules: [
            {
              required: true,
              type: "number",
              message: this.$t("enter") + this.$t("caseNumber"),
              trigger: "blur",
            },
          ],
          InputNumber: true,
        },
        {
          title: '数量',
          align: "center",
          slot: "outNumber",
          rules: [
            {
              required: true,
              type: "number",
              message: this.$t("enter") + this.$t("outNumber"),
              trigger: "blur",
            },
          ],
          InputNumber: true,
        },
        {
          title: this.$t("operation"),
          align: "center",
          slot: "operation",
          button: true,
        },
      ],
      tableTitle1: [
        {
          title: this.$tz("商品,ID"),
          align: "center",
          slot: "goods_id",
          input: true,
          placeholder: this.$t("goodsIdPlaceholder"),
          rules: [
            {
              required: true,
              message: this.$t("goodsIdPlaceholder"),
              trigger: "blur",
            },
          ],
        },
        {
          title: this.$tz("数量,(,PCS,)"),
          align: "center",
          slot: "goods_pcs",
          input: true,
          placeholder: this.$tz("請輸入,數量,(,PCS,)"),
          rules: [
            {
              required: true,
              message: this.$tz("不能为空"),
              trigger: "blur",
            },
          ],
        },
        {
          title: this.$t("operation"),
          align: "center",
          slot: "operation",
          button: true,
        },
      ],
      fromCountry: [],
      toCountry: [],
      channelList: [],
      seiviceList: [],
      transport: [],
      warehouseList: [],
      clientList: [],
      countryCode: "000",
      currencyList: [],
      cityList: [],
      checkCountry: {}
    };
  },
  mounted() {
    this.getOtherList();
    platformType().then((res) => {
      this.platform = res.data.payload;
    });
  },
  methods: {
    filterCountry(item) {
      if (item.selected === 0) {
        return true
      }

      if (['FBA', 'FBN'].includes(this.dataDetails.consigneeInfo.company)) {
        return !['SA', 'AE', 'EG'].includes(item.to_country.code)
      }
      if (['FBJ'].includes(this.dataDetails.consigneeInfo.company)) {
        return !['EG'].includes(item.to_country.code)
      }
      return false
    },
    addPlatform() {
      this.dataDetails.platformInfo.push({
        goods_id: "",
        goods_pcs: "",
      });
    },
    delPlatform(index) {
      this.dataDetails.platformInfo.splice(index, 1);
    },
    getOtherList() {
      getAddress().then((res) => {
        this.channelList = [];
        this.warehouseList = [];
        res.data.payload.forEach((item) => {
          this.channelList.push(item);
          this.warehouseList.push({
            code: item.warehouse_name,
            selected: 0,
            to_country: item.to_country,
            from_country: item.from_country,
            service_code: item.service_code,
            address: item.detailed_address,
            phone: item.phone,
          });
        });
      });
      getService().then((res) => {
        this.seiviceList = res.data.payload;
      });
      getServiceCountry().then((res) => {
        this.fromCountry = res.data.payload.fromCountry;
        Object.values(res.data.payload.toCountry).forEach((item) => {
          this.toCountry.push({ to_country: item, selected: 1 });
        });
        this.transport = res.data.payload.transport;
        this.medList = JSON.parse(JSON.stringify(res.data.payload.transport));
        this.checkCountry = res.data.payload.country_relate;
      });
      getAllClient({business: 'count'}).then((res) => {
        this.clientList = res.data.payload.rows;
      });
      getCurrency().then((res) => {
        this.currencyList = res.data.payload.rows;
      });
      // getCity().then((res) => {
      //   this.cityList = res.data.payload.rows;
      // });
    },
    changeFrom(val) {
      if (val) {
        this.changeSelect(val, "from");
        this.dataDetails.consigneeInfo.country = "";
        console.log(this.checkCountry)
        this.toCountry = this.checkCountry[val].toCountry;
        this.transport = this.checkCountry[val].transport;
      }
    },
    changeWarehouse(val) {
      this.warehouseList.forEach((item) => {
        if (item.code == val) {
          this.dataDetails.consigneeInfo.address = item.address;
          this.dataDetails.consigneeInfo.mobile = item.phone;
        }
      });
    },
    changeTo(val) {
      if (val) {
        this.changeSelect(val, "to");
        getCountry({ keywords: val, keywordsType: 'code' }).then((res) => {
          this.countryCode = res.data.payload.rows[0].country_code;
        });
        getCountryCity(val, 'code').then(r => {
          this.$data.cityList = r.data.payload
        })
        // console.log(val + '@xxx', this.$data.cityList);
        this.warehouseList.forEach((item) => {
          if (
            item.to_country == val &&
            item.service_code == this.dataDetails.consigneeInfo.company
          ) {
            item.selected = 1;
          } else {
            item.selected = 0;
          }
        });
        this.$forceUpdate()
      }
    },
    serviceChange(val) {
      if (val) {
        if (["men", "AIR-Truck", "SEA-Truck"].includes(val)) {
        }
        this.changeSelect(val);
        this.transport = this.medList;
        this.warehouseList.forEach((item) => {
          if (item.service_code == val) {
            item.selected = 1;
          } else {
            item.selected = 0;
          }
        });
      }
    },
    inputRef(e) {
      let val = e.target.value;
      this.$emit("inputRef", val);
    },
    changeRadio(val) {
      this.$emit("changeRadio", val);
    },
    addSubmit() {
      this.$emit("addSubmit");
    },
    delSubmit(val) {
      this.$emit("delSubmit", val);
    },
    isInt(rule, value, callback) {
      if (!value) {
        return callback(new Error("Cannot be empty"));
      }
      this.$nextTick(() => {
        var reg = new RegExp(/^\d+$/);
        if (!reg.test(value)) {
          callback(new Error("Must be a positive integer"));
        } else {
          if (value < 1) {
            callback(new Error("The minimum value is 1"));
          } else {
            callback();
          }
        }
      });
    },
    changeSelect(text, type) {
      if (type == "from") {
        let company = this.dataDetails.consigneeInfo.company;
        this.dataDetails.consigneeInfo = {};
        this.dataDetails.consigneeInfo.company = company;
        this.dataDetails.consigneeInfo.origin = text;
      } else if (type == "to") {
        let company = this.dataDetails.consigneeInfo.company;
        let origin = this.dataDetails.consigneeInfo.origin;
        this.dataDetails.consigneeInfo = {};
        this.dataDetails.consigneeInfo.company = company;
        this.dataDetails.consigneeInfo.origin = origin;
        this.dataDetails.consigneeInfo.country = text;
      } else {
        this.dataDetails.consigneeInfo = {};
        this.dataDetails.consigneeInfo.company = text;
      }
      this.dataDetails.consigneeInfo.contact = "";
      this.countryCode = "000";
    },
  },
};
</script>

//
<style lang="less" scoped>
.order-div {
  // height: 100%;
  border-radius: 6px;
  /deep/ .ivu-card-body {
    padding-bottom: 0;
  }
  .table-card {
    /deep/ .ivu-card-body {
      padding-bottom: 16px;
    }
  }
}
.ivu-form-item {
  width: 100%;
}
</style>
